// Shared energy-provider branding: logo slugs (files in public/logos/),
// brand colours, and the circular logo component with initials fallback.
// Used by ProviderComparison (sidebar leaderboard) and MapToolbar (filter pills).
import React, { useState } from "react";
import Box from "@mui/material/Box";

export const PROVIDER_LOGO_SLUGS = {
  "British Gas": "britishgas",
  "E.ON / E.ON Next": "eon",
  "EDF Energy": "edf",
  "Octopus Energy": "octoenergy",
  "Ovo Energy": "ovo",
  "Scottish Power": "scottishpower",
};

export const PROVIDER_COLORS = {
  "British Gas": "#0072CE",
  "E.ON / E.ON Next": "#E30613",
  "EDF Energy": "#FF6600",
  "Octopus Energy": "#E20074",
  "Ovo Energy": "#2ECC71",
  "Scottish Power": "#003DA5",
  "Other": "#999",
  "Don't know": "#ccc",
};

export default function ProviderLogo({ name, size = 28 }) {
  const slug = PROVIDER_LOGO_SLUGS[name];
  const [failed, setFailed] = useState(false);

  if (!slug || failed) {
    const color = PROVIDER_COLORS[name] || "#888";
    const initials = name.split(/\s+/).map(w => w[0]).join("").slice(0, 2).toUpperCase();
    return (
      <Box sx={{
        width: size, height: size, borderRadius: "50%", bgcolor: color,
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "#fff", fontSize: size * 0.38, fontWeight: 700, flexShrink: 0,
        fontFamily: "'DM Sans', sans-serif",
      }}>
        {initials}
      </Box>
    );
  }

  return (
    <Box sx={{
      width: size, height: size, borderRadius: "50%", overflow: "hidden",
      flexShrink: 0, bgcolor: "#f5f5f5",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <img
        src={`${process.env.PUBLIC_URL}/logos/${slug}.png`}
        alt={name}
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        onError={() => setFailed(true)}
      />
    </Box>
  );
}
